import { render, staticRenderFns } from "./UserReset.vue?vue&type=template&id=443af4ea"
import script from "./UserReset.vue?vue&type=script&lang=js"
export * from "./UserReset.vue?vue&type=script&lang=js"
import style0 from "./UserReset.vue?vue&type=style&index=0&id=443af4ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports